module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/arrow-56f2f99772985ad85f5af6fd3e7c735b.svg";